// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Ensure it's above other elements */
}

.modal-content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  min-width: 300px;
  max-width: 500px;
}

.modal-content h2 {
  margin: 0 0 20px 0;
  color: #2c3e50;
  text-align: center;
  font-size: 1.5em;
}

.modal-content button {
  padding: 12px 20px;
  border: none;
  border-radius: 5px;
  font-size: 1em;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.modal-content button:not(:last-child) {
  background-color: #007bff;
  color: white;
}

.modal-content button:not(:last-child):hover {
  background-color: #0056b3;
}

.modal-content button:last-child {
  background-color: #6c757d;
  color: white;
  margin-top: 10px;
}

.modal-content button:last-child:hover {
  background-color: #5a6268;
}
`, "",{"version":3,"sources":["webpack://./src/components/VoiceModelSelectionModal.css"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,qCAAqC;AACtD;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000; /* Ensure it's above other elements */\n}\n\n.modal-content {\n  background: white;\n  padding: 30px;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n  min-width: 300px;\n  max-width: 500px;\n}\n\n.modal-content h2 {\n  margin: 0 0 20px 0;\n  color: #2c3e50;\n  text-align: center;\n  font-size: 1.5em;\n}\n\n.modal-content button {\n  padding: 12px 20px;\n  border: none;\n  border-radius: 5px;\n  font-size: 1em;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.modal-content button:not(:last-child) {\n  background-color: #007bff;\n  color: white;\n}\n\n.modal-content button:not(:last-child):hover {\n  background-color: #0056b3;\n}\n\n.modal-content button:last-child {\n  background-color: #6c757d;\n  color: white;\n  margin-top: 10px;\n}\n\n.modal-content button:last-child:hover {\n  background-color: #5a6268;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
